import { LoadState } from "../../constants/enums";
import { ILeadsData, ILeadsDataState } from "./leadsData.types";

export const defaultLeadsData: ILeadsData = {
    leaddata_id: null,
    primary_source: null,
    seconday_source: null,
    user_name: null,
    mobile_number: null,
    vehicle_number: null,
    plan_name: null,
    membership_start_date: null,
    membership_expiry_date: null,
    intrested_flag: null,
    remark: null,
    comment: null,
    status: null,
    created_dt: null,
    insert_dt: null,
};

export const LeadsDataInitialState: ILeadsDataState = {
    list: {
        data: [],
        totalRecords: 0,
        loading: LoadState.NotLoaded,
        error: null,
    },
    leadData: {
        data: defaultLeadsData,
        loading: LoadState.NotLoaded,
        error: null,
    },
};
